import React from 'react';
import { stripParagraphTag } from 'helpers/text';

import styles from './styles.scss';

const JobDetailHeader = props => {
  const { data } = props;

  return (
    <header className={styles.jobDetailHeader}>
      {data ? (
        <span className={styles.jobDetailHeader__meta}>
          <span className={styles.jobDetailHeader__label}>Careers</span>
          <span className={styles.jobDetailHeader__separator}>&mdash;</span>
        </span>
      ) : null}
      <h1
        className={styles.jobDetailHeader__title}
        dangerouslySetInnerHTML={{ __html: data ? stripParagraphTag(data.title) : null }}
      />
    </header>
  );
};

export default JobDetailHeader;
